import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EmailVM } from 'src/app/viewModels/common/email-vm';
import { CommonService } from 'src/app/middleware/common/common.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
 
    ForgotPassForm: FormGroup;
    forgotPasswordCheckUserResponseHolder: any;
    
  constructor(private _formBuilder: FormBuilder, private emailVM: EmailVM,
    private commonService: CommonService, private loaderService: LoaderService,
    private toastr: ToastrService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConst: StatusConstant,
    private router: Router) { }

  ngOnInit(): void {
    this.ForgotPassForm = this._formBuilder.group({
      //email: ['', [Validators.required, Validators.email]]
      email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
    });
  }


  forgotPassword(formValues) {
    if (formValues != undefined) {
      if(formValues.email=="" || formValues.email==undefined || formValues.email==null){
        this.toastr.warning("please enter email id", '', {
          timeOut: 3000,
        });
        return
      }
      this.ForgotPassForm.setErrors({ 'invalid': true });
      let copyModel = Object.assign({}, this.emailVM);
      copyModel.email = formValues.email;
      copyModel.email = this.encryptionAlgo.set(this.reusableClass.encryptionKey, copyModel.email);
      this.emailVM = copyModel;
    }    
    this.loaderService.show();
    this.commonService.forgotPasswordCheckUser(this.emailVM).subscribe(response => {
      this.loaderService.hide();
      if (response) {
        this.forgotPasswordCheckUserResponseHolder = response;
        this.ForgotPassForm.setErrors({ 'invalid': true });
        if (this.forgotPasswordCheckUserResponseHolder.status == this.statusConst.statusSuccess) {           
          this.toastr.success("Link has been shared on provided mail address, please check!.", '', {
            timeOut: 3000,
          });
         // this.router.navigate(['/auth/login']);
        }
        else {
          this.loaderService.hide();
          this.toastr.error(this.forgotPasswordCheckUserResponseHolder.message, '', {
            timeOut: 3000,
          });
        }
      }
      else{
        this.loaderService.hide();
      }
    });
  }

}
